<template>
  <b-modal
    id="form-url-modal"
    :footer-class="
      isEvent ? 'd-flex justify-content-end' : 'd-flex justify-content-center'
    "
  >
    <template #modal-header="{ close }">
      <h5 class="m-0 align-self-center">{{ formTitle }}</h5>
      <b-button size="sm" variant="link" class="text-dark" @click="close()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 320 512"
          style="height: 20px"
        >
          <path
            d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
          />
        </svg>
      </b-button>
    </template>
    <template v-if="isEvent">
      <h5 class="mb-2">填寫網址</h5>
      <b-textarea
        id="form-url"
        v-b-tooltip.click="'已複製'"
        v-model="formUrl"
        @click="copyFormUrl('#form-url')"
      ></b-textarea>
      <div v-if="formUrl" class="d-flex flex-column align-items-center">
        <vue-qr :text="formUrl" ref="formQRcode"></vue-qr>
        <b-button
          variant="primary"
          class="center-button"
          @click="downloadQRCode($refs.formQRcode, `${formTitle}_填寫網址`)"
        >
          下載QRCode
        </b-button>
      </div>
      <hr class="my-4" v-if="checkinUrl" />
      <template v-if="!!checkinUrl">
        <h5 class="my-2">報到網址</h5>
        <b-textarea
          id="checkin-url"
          v-b-tooltip.click="'已複製'"
          v-model="checkinUrl"
          @click="copyFormUrl('#checkin-url')"
        ></b-textarea>
        <div v-if="checkinUrl" class="d-flex flex-column align-items-center">
          <vue-qr :text="checkinUrl" ref="checkinQRcode"></vue-qr>
          <b-button
            variant="primary"
            class="center-button"
            @click="
              downloadQRCode($refs.checkinQRcode, `${formTitle}_報到網址`)
            "
          >
            下載QRCode
          </b-button>
        </div>
      </template>
    </template>
    <template v-else>
      <div class="d-flex flex-column align-items-center">
        <h5 class="mb-2">填寫網址</h5>
        <b-textarea
          id="form-url"
          v-b-tooltip.click="'已複製'"
          v-model="formUrl"
          @click="copyFormUrl('#form-url')"
        ></b-textarea>
        <div>
          <vue-qr :text="formUrl" ref="formQRcode"></vue-qr>
        </div>
      </div>
    </template>
    <template #modal-footer>
      <div
        class="modal-button-group d-flex w-100 align-items-center"
        style="position: relative; min-height: 42px"
      >
        <div v-if="!isEvent" class="flex-grow-1 d-flex justify-content-center">
          <b-button
            variant="primary"
            @click="downloadQRCode($refs.formQRcode, `${formTitle}_填寫網址`)"
          >
            下載QRCode
          </b-button>
        </div>
        <b-button
          variant="danger"
          style="position: absolute; right: 0"
          @click="$bvModal.hide('form-url-modal')"
        >
          關閉
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "FormUrlModal",
  components: { VueQr: () => import("vue-qr") },
  props: {
    form: Object,
    formTitle: String,
    formUrl: String,
    checkinUrl: String,
  },
  computed: {
    isEvent() {
      return this.form && this.form.type === "event";
    },
  },
  methods: {
    copyFormUrl(id) {
      const inputText = document.querySelector(id);
      inputText.select();
      document.execCommand("copy");
    },
    downloadQRCode(ref, filename) {
      const base64QRCodeImage = ref?.$el?.src;
      if (base64QRCodeImage) {
        const temporaryDownloadLink = document.createElement("a");
        temporaryDownloadLink.href = base64QRCodeImage;
        temporaryDownloadLink.download = filename
          ? `${filename}.png`
          : "qrcode.png";
        temporaryDownloadLink.style.display = "none";
        document.body.appendChild(temporaryDownloadLink);
        temporaryDownloadLink.click();
        document.body.removeChild(temporaryDownloadLink);
      }
    },
  },
};
</script>
